import { atom } from 'nanostores';

export const $isHalfView = atom<boolean>(true)